import Application from "../../Application";
import GetGenericCodebookInteractor from "../../codebooks/interactor/GetGenericCodebookInteractor";
import { ContentTypes } from "../../caseLawDocuments/common/Constants";
import GetAllOrganisationAttachmentTypesInteractor from "./GetAllOrganisationAttachmentTypesInteractor";
import OrganisationAttachmentTypePresenter, {
  IOrganisationAttachmentTypePresenter
} from "../presenter/OrganisationAttachmentTypePresenter";
import GetOrganisationInteractor from "./GetOrganisationInteractor";
import { IOrganisation } from "../model/Organisation";

export default class ShowOrganisationAttachmentTypesInteractor {
  private application: Application;
  private output?: IOrganisationAttachmentTypePresenter;
  private getOrganisationInteractor: GetOrganisationInteractor;
  private getAllOrganisationAttachmentTypesInteractor: GetAllOrganisationAttachmentTypesInteractor;
  private getGenericCodebookInteractor: GetGenericCodebookInteractor;

  constructor({
    application,
    getAllOrganisationAttachmentTypes,
    getOrganisation,
    getGenericCodebook
  }) {
    this.application = application;
    this.getAllOrganisationAttachmentTypesInteractor =
      getAllOrganisationAttachmentTypes;
    this.getGenericCodebookInteractor = getGenericCodebook;
    this.getOrganisationInteractor = getOrganisation;
  }
  private async getContentTypes() {
    return this.getGenericCodebookInteractor.execute(
      ContentTypes.ATTACHMENT_CONTENT_TYPE,
      false
    );
  }
  private async getOrganisation(organisationId) {
    return this.getOrganisationInteractor.execute(organisationId);
  }
  private async getReferenceLists(organisationId: number) {
    return Promise.all([
      this.getContentTypes(),
      this.getOrganisation(organisationId)
    ]);
  }
  execute(organisationId: number) {
    this.output = OrganisationAttachmentTypePresenter({
      application: this.application,

      initialState: {
        attachmentTypes: [],
        contentTypes: [],
        organisationId,
        organisation: {} as IOrganisation
      }
    });
    this.getReferenceLists(organisationId)
      .then(([contentTypes, organisation]) =>
        this.output?.loadAttachmentTypeReferenceValues(
          contentTypes,
          organisation
        )
      )
      .then(() =>
        this.getAllOrganisationAttachmentTypesInteractor.execute(organisationId)
      )
      .then(this.output.loadAllAttachmentTypes);
    return this.output;
  }
}
